import * as React from 'react';
import { Container, Row, Col, Button, Label } from 'reactstrap';
import * as _ from 'lodash';
import { toastr } from 'react-redux-toastr';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { History } from 'history';
import { PulseLoader } from 'react-spinners';
import * as ReactGA from 'react-ga';
import { IAuthState } from "../../Auth/store/types";
import { WrappedInput } from '../../../share/components/Input/Input';
import { Form } from '../../../share/components/Form/Form';
import { IReduxState } from '../../../reduxTypes';
import { loginActions } from '../../Auth/store/actions';
import { CognitoLoginService } from '../../../share/services/cognito-login';
import { cognitoInfo } from '../../../share/config/cognito';
import { isStrongEnough } from '../../../share/utils/passwordValidator';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import './changePassword.css';
import { RoutesModules } from 'src/modules/Routing/types';

export interface IChangePasswordProps {
    auth: IAuthState;
    onLogout: (history: any) => any;
    history: History;
}

export interface IChangePasswordState {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
    loading: boolean;
    loadingMessage: string
}

export class ChangePassword extends React.Component<IChangePasswordProps, IChangePasswordState> {
    constructor(props: IChangePasswordProps) {
        super(props);

        this.state = {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            loading: false,
            loadingMessage: "Loading",
        };
    }

    public setValue = (key: string, value: any) => {
        const newState = { ...this.state };
        _.set(newState, key, value);
        this.setState(newState);
    }

    public onChange = (key: string, event) => {
        this.setValue(key, event.currentTarget.value);
    }

    public handleInvalidSubmit() {
        toastr.error('Change Password', 'Please fill all the required values')
    }

    public arePasswordsEqual(newPassword: string, confirmPassword: string) {
        return newPassword === confirmPassword;
    }

    public isFormValid(): string[] {
        const {
            newPassword,
            confirmPassword
        } = this.state;
        const errors: string[] = [];
        if (!this.arePasswordsEqual(newPassword, confirmPassword)) {
            errors.push("Passwords do not match.");
        }
        if (!isStrongEnough(newPassword)) {
            errors.push("Password must be 10 characters long, have uppercase "
                + "and lowercase letters, numbers and at least one special character: ?, -, *, +");
        }
        return errors;
    }

    public handleValidSubmit = async () => {
        const errors = this.isFormValid();
        if (errors.length === 0) {
            this.setState({ loading: true, loadingMessage: 'Updating pasword' });
            try {
                const cognitoService = new CognitoLoginService(cognitoInfo);
                await cognitoService.changePassword(
                    this.props.auth.username,
                    this.state.currentPassword
                    , this.state.newPassword);
                this.setState({ loading: false, loadingMessage: '' });
                toastr.success('Password changed', 'Please login again');
                ReactGA.event({
                    category: 'Password',
                    action: 'Changed user password',
                    label: 'Password management'
                });
                this.props.onLogout(this.props.history);
            } catch (error) {
                this.setState({ loading: false, loadingMessage: '' });
                toastr.error('Error', error.message);
            }
        } else {
            toastr.error('Error', errors.join("\n"));
        }
    }

    public render() {
        const { currentPassword
            , newPassword
            , confirmPassword
            , loading
            , loadingMessage } = this.state;

        const passwordValidationClass = !this.arePasswordsEqual(newPassword, confirmPassword)
            ? "text-danger" : undefined;
        return (
            <Container className="change-password-container white-background">
                <h1>Change password</h1>
                <Form onInvalidSubmit={this.handleInvalidSubmit}
                    onValidSubmit={this.handleValidSubmit}
                    className="subFont">
                    <Row>
                        <WrappedInput id="currentPassword" type="password"
                            className="subFont"
                            name="currentPassword"
                            md={12}
                            placeholder="Old password"
                            value={currentPassword}
                            required={true}
                            onChange={(event) => this.onChange('currentPassword', event)} />
                    </Row>
                    <Row>
                        <WrappedInput id="newPassword" type="password"
                            name="newPassword"
                            md={12}
                            placeholder="New password"
                            value={newPassword}
                            required={true}
                            className={passwordValidationClass + ' subFont'}
                            onChange={(event) => this.onChange('newPassword', event)} />
                    </Row>
                    <Row>
                        <WrappedInput id="confirmPassword" type="password"
                            name="confirmPassword"
                            md={12}
                            placeholder="Confirm new password"
                            value={confirmPassword}
                            required={true}
                            className={passwordValidationClass + ' subFont'}
                            onChange={(event) => this.onChange('confirmPassword', event)} />
                    </Row>
                    <Row>
                        <Col md={5} className="change-password-required">
                            <p className="required">*Required field</p>
                        </Col>
                        <Col md={7} className="change-password-buttons">
                            {
                                loading &&
                                <>
                                    <Label id="loadingText" className="text-center saving-text">{loadingMessage}</Label>
                                    <PulseLoader size={15} color={'#db8733'} loading={loading} />
                                </>
                            }
                            <Button type="submit" id="submitPasswordChange"
                                className="btn btn-outline btn-green-fill float-right">
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({
        onLogout: loginActions.logout
    }, dispatch);
}

export default SidebarContainer(RoutesModules.SETTINGS)(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));


// WEBPACK FOOTER //
// ./src/modules/UserSettings/ChangePassword/ChangePassword.tsx